import styled from 'styled-components';

const Image = styled.img`
    margin: 0;
    padding: 0;
`;

const RoundedImage = styled(Image)`
    border-radius: 50%;
    cursor: pointer;
    height: ${({ height = '35px' }) => height};
    width: ${({ width = '35px' }) => width};
    ${({ styles }) => styles && { ...styles }};
`;

export {
    Image,
    RoundedImage,
};
